module.exports = __webpack_public_path__ + "img/pending-icon.645ebff0.png";